module.exports = __webpack_public_path__ + "img/logo.d63297be.jpg";